import { useEffect, useState } from "react";
import api from "@/lib/api";

export function useEmployees() {
  const [employees, setEmployees] = useState([]);
  useEffect(() => {
    api.get("/employees").then((r) =>
      setEmployees((r.data || []).filter((e) => ["executive", "sde", "sdl"].includes(e.role)))
    ).catch(() => {});
  }, []);
  return employees;
}
